import angular, { IOnInit } from "angular";
import { ColDef } from "../../../../records/grids/columns/colDef";
import {
  GridSelectionChangedArgs,
  IRowCommandEventArgs,
} from "../../../../records/grids/controller";
import {
  IGridSettings,
  vsName as GridSettingsServiceName,
  GridSettingsService,
} from "../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../records/server/query";
import { Machine } from "../../models/machine";
import {
  MachineConfiguration,
  MachineConfigurationView,
} from "../../models/machineConfiguration";
const colId = Symbol("main.selectMachine");
export interface MachineSelectEventArgs {
  machine: Machine;
}

export interface SelectMachineModalConfig {
  showSelectButtons?: boolean;
  decorateCurrentAndFutureConfigurations?: boolean;
  defaultQuery?: IQuery;
  additionalColumns?: ColDef[];
  gridSelectionChanged?: (
    args: GridSelectionChangedArgs,
    modalInstance: angular.ui.bootstrap.IModalInstanceService
  ) => void;
  onItemCommand?: (
    args: IRowCommandEventArgs<MachineConfigurationView>,
    modalInstance: angular.ui.bootstrap.IModalInstanceService
  ) => void;
}

export class SelectMachineModalController implements IOnInit {
  static $inject = [  GridSettingsServiceName];

  private config!: SelectMachineModalConfig;

  additionalColumns!: ColDef[];
  gridSettings: IGridSettings ;
  defaultQuery!: IQuery;
  decorateCurrentAndFutureConfigurations!: boolean;
  showSelectButtons!: boolean;
  resolve!: { machineModalConfig: SelectMachineModalConfig };  
  modalInstance!: angular.ui.bootstrap.IModalInstanceService;

  onItemCommand(args: IRowCommandEventArgs<MachineConfiguration>) {
    if (this.config.onItemCommand) {
      this.config.onItemCommand(
        {
          commandName: args.commandName,
          data: this.changeConfigurationToMachine(args.data),
        },
        this.modalInstance
      );
    }
  }

  //there's some gross typing going on here.  Query is made to configuration endpoint but we are treating as machine.
  // this also means the
  private changeConfigurationToMachine(
    machine: Machine
  ): MachineConfigurationView {
    const newMachine = { ...machine };
    delete newMachine.MachineId;
    newMachine.Id = <number>machine.MachineId;
    newMachine.MachineConfigurationId = machine.Id;
    return <MachineConfigurationView>newMachine;
  }

  gridSelectionChanged(args: GridSelectionChangedArgs) {
    if (this.config.gridSelectionChanged) {
      this.config.gridSelectionChanged(args, this.modalInstance);
    }
  }

  constructor( gridSettingService: GridSettingsService,) {
    this.setModalWidth("950px");
    this.gridSettings = gridSettingService.getGridSettings(colId);
  }

  $onInit(): void {
    const config = (this.config = this.resolve.machineModalConfig);
    this.additionalColumns = config?.additionalColumns ?? [];
    this.defaultQuery = config?.defaultQuery ?? {};
    this.decorateCurrentAndFutureConfigurations =
      config?.decorateCurrentAndFutureConfigurations ?? false;
    this.showSelectButtons = config?.showSelectButtons ?? false;
  }

  private setModalWidth(width: string) {
    const elements = document.querySelector(".modal-content");
    if (!elements) return;
    var modalWindow = angular.element(elements);
    modalWindow.css("width", width);
  }
}
/*
 *   - `close` - A method that can be used to close a modal, passing a result. The result must be passed in this format: `{$value: myResult}`
 *   - `dismiss` - A method that can be used to dismiss a modal, passing a result. The result must be passed in this format: `{$value: myRejectedResult}`
 *   - `modalInstance` - The modal instance. This is the same `$uibModalInstance` injectable found when using `controller`.
 *   - `resolve` - An object of the modal resolve values. See [UI Router resolves] for details.
 *
 */
